// Module
var code = "<script id=\"wcc-components-fancybox-youtube-new\" type=\"text/template\">\r\n    <!-- ko if: isReady -->\r\n    <fancybox-video-iframe-new params=\"src: src, thumbnail: thumbnail\"></fancybox-video-iframe-new>\r\n    <!-- /ko -->\r\n</script>";
// Exports
module.exports = code;